// extracted by mini-css-extract-plugin
export default {"container":"ro-z","ratingLayout":"so-z","ratingLabel":"to-z","nonInteractiveRatingLabel":"uo-z"};